module.exports = __webpack_public_path__ + "media/src/assets/Images/LandingTick-2bd1c1dd44cc75abc8c80f9262dd9f56.svg";